import { Navigate, Route, useParams } from "react-router-dom";


//Routes per la retrocompatibilità con HD legacy per chi ha ancora vecchi link salvati (non funziona per routing a url vecchi fatti direttamente dentro all'iframe)
function useLegacyRedirectRoutes() {
  
  function ContactsEditRedirect(){
    const {id} = useParams();
    return <Navigate to={`/contacts-edit/${id}`} replace />;
  }

  function ContactsDetailsRedirect(){
    const {id} = useParams();
    return <Navigate to={`/contacts-edit/${id}`} replace />;
  }

  return (
    <>
      {/* redirect a nuova sezione report preventivi leisure */}
      <Route
        path="QuotationReport/*"
        element={
          <Navigate to="/leisure-reports" replace />
        }
      />
      {/* redirect a nuova sezione edit contatto */}
      <Route
          path="Contacts/Edit/:id"
          element={
          <ContactsEditRedirect />
        }
        />
      {/* redirect a nuova sezione create contatto (edit con id 0) */}
      <Route
        path="Contacts/Create"
        element={
        <Navigate to="/contacts-edit/0" replace />
      }
      />
      {/* redirect a sezione edit contatto 
      (non esiste una pagina di details nell'area nuova ma solo il contactPanel, 
      in futuro valutare di mandare ad una pagina dove in automatico viene aperto il contactPanel sul contatto specifico) */}
      <Route
        path="Contacts/Detail/:id"
        element={
          <ContactsDetailsRedirect />
        }
      />
    </>
  );
}

export default useLegacyRedirectRoutes;